module.exports = __webpack_public_path__ + "img/keyboard_65_game_boy.ccc4c3ea.png";